import { baseApi } from '@/api/core/baseApi';
import type { Schema } from '@voley/shared-types';
import type { TenDlcApplication, CreateTenDlcApplicationRequest } from '../types';

export const tenDlcApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTenDlcApplications: build.query<TenDlcApplication[], void>({
      query: () => ({
        url: '/ten-dlc/applications',
        method: 'GET',
      }),
      transformResponse: (resp: Schema<'TwilioTenDlcApplicationsListResponse'>) => resp.data,
      providesTags: (result) =>
        result
          ? [
              ...result.map((r) => ({ type: 'TenDlc' as const, id: r.id })),
              { type: 'TenDlc' as const, id: 'LIST' },
            ]
          : [{ type: 'TenDlc' as const, id: 'LIST' }],
    }),

    createTenDlcApplication: build.mutation<TenDlcApplication, CreateTenDlcApplicationRequest>({
      query: (body) => ({
        url: '/ten-dlc/applications',
        method: 'POST',
        body,
      }),
      transformResponse: (resp: Schema<'TwilioTenDlcApplicationCreateResponse'>) => resp.data,
      invalidatesTags: [{ type: 'TenDlc', id: 'LIST' }],
    }),
  }),
});

export const { useGetTenDlcApplicationsQuery, useCreateTenDlcApplicationMutation } = tenDlcApi;
